import React, { useState } from 'react';

const ContactUs = () => {
    const [formData, setFormData] = useState({
        name: '',
        mobile: '',
        email: '',
        company: '',
    });
    const [status, setStatus] = useState('idle'); // 'idle', 'sending', 'success', 'error'
    const [message, setMessage] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('sending');
        setMessage('');

        try {
            const response = await fetch('/api/send-telegram', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();

            if (response.ok) {
                setStatus('success');
                setMessage('Thank you! Your enquiry has been sent successfully.');
                setFormData({ name: '', mobile: '', email: '', company: '' });
            } else {
                setStatus('error');
                setMessage(result.error || 'An error occurred. Please try again.');
            }
        } catch (error) {
            setStatus('error');
            setMessage('A network error occurred. Please try again.');
        }
    };

    return (
        <section id="contact" className="bg-gray-800 text-white py-20">
            <div className="container mx-auto px-6">
                <h2 className="text-3xl md:text-4xl font-serif-display text-center font-bold mb-12 section-title">Request a Consultation</h2>
                <div className="max-w-2xl mx-auto bg-gray-900 p-8 md:p-12 rounded-lg shadow-2xl">
                    <p className="text-center text-gray-300 mb-8">Let's discuss how we can bring clarity to your insurance needs. Fill out the form below and one of our expert advisors will be in touch shortly.</p>
                    <form onSubmit={handleSubmit}>
                        <div className="space-y-6">
                            <div>
                                <label htmlFor="name" className="block mb-2 font-semibold">Full Name</label>
                                <input type="text" id="name" name="name" required className="w-full p-3 rounded-md bg-gray-700 border border-gray-600 focus:border-yellow-500 focus:ring-yellow-500" placeholder="Your Full Name" value={formData.name} onChange={handleChange} />
                            </div>
                            <div>
                                <label htmlFor="mobile" className="block mb-2 font-semibold">Mobile No.</label>
                                <input type="tel" id="mobile" name="mobile" required className="w-full p-3 rounded-md bg-gray-700 border border-gray-600 focus:border-yellow-500 focus:ring-yellow-500" placeholder="Your 10-Digit Mobile Number" value={formData.mobile} onChange={handleChange} />
                            </div>
                            <div>
                                <label htmlFor="email" className="block mb-2 font-semibold">Email ID</label>
                                <input type="email" id="email" name="email" required className="w-full p-3 rounded-md bg-gray-700 border border-gray-600 focus:border-yellow-500 focus:ring-yellow-500" placeholder="your.email@example.com" value={formData.email} onChange={handleChange} />
                            </div>
                            <div>
                                <label htmlFor="company" className="block mb-2 font-semibold">Company Name</label>
                                <input type="text" id="company" name="company" required className="w-full p-3 rounded-md bg-gray-700 border border-gray-600 focus:border-yellow-500 focus:ring-yellow-500" placeholder="Your Company's Name" value={formData.company} onChange={handleChange} />
                            </div>
                        </div>
                        <div className="text-center mt-8">
                            <button type="submit" className="btn-gold font-bold py-3 px-8 rounded-full text-lg transition duration-300" disabled={status === 'sending'}>
                                {status === 'sending' ? 'Sending...' : 'Send Enquiry'}
                            </button>
                        </div>
                        {message && (
                            <p className={`mt-4 text-center ${status === 'success' ? 'text-green-400' : 'text-red-400'}`}>
                                {message}
                            </p>
                        )}
                    </form>
                </div>
            </div>
        </section>
    );
};

export default ContactUs;
